import {Component, Input, OnInit} from "@angular/core";
import {Role} from "../../../shared/api/roles/api.models";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Api} from "../../../shared/api.service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'role-modal',
    template: require('./role.modal.html'),
    styles: [require('./role.modal.scss')]
})

export class RoleModal implements OnInit {
    @Input() role: Role;
    @Input() roles: Role[];

    roleForm: FormGroup;
    apiError: string;
    levels: number[] = [];

    constructor(public activeModal: NgbActiveModal, private fb: FormBuilder, private api: Api) {}

    ngOnInit() {
        let length = this.roles.length;
        if (!this.role.id) {
            length++;
        }

        for (let i = 1; i <= length; i++) {
            this.levels.push(i);
        }

        this.roleForm = this.fb.group({
            id : [this.role.id],
            name : [
                this.role.name,
                [
                    Validators.required,
                    Validators.minLength(4),
                    Validators.maxLength(50),
                    Validators.pattern(/^[0-9a-zA-Z]+$/),
                    (input: FormControl) => {
                        if (!input.value) {
                            return null;
                        }

                        let found = false;

                        for (let i = 0; i < this.roles.length; i++) {
                            if (
                                this.roles[i].name.toLowerCase() === input.value.toLowerCase() &&
                                this.roles[i].id !== this.role.id
                            ) {
                                found = true;
                                break;
                            }
                        }

                        if (found === true) {
                            return {nametaken: true};
                        }

                        return null;
                    }
                ]
            ],
            description : [
                this.role.description,
                [
                    Validators.required,
                    Validators.minLength(10),
                    Validators.maxLength(50)
                ]
            ],
            level : [
                this.role.level,
                [
                    Validators.required
                ]
            ]
        });

        this.roleForm.valueChanges.subscribe((role: Role) => {
            Object.assign(this.role, role);
        });
    }

    save() {
        this.apiError = null;

        if (this.role.id) {
            this.api.roles().update(this.role).subscribe(
                (role: Role) => {
                    this.activeModal.close(role);
                },
                (error: any) => {
                    if (error.errors) {
                        this.apiError = error.errors[0].detail;
                    } else {
                        this.apiError = error.error.message;
                    }
                }
            );

            return;
        }

        this.api.roles().add(this.role).subscribe(
            (role: Role) => {
                this.activeModal.close(role);
            },
            (error: any) => {
                if (error.errors) {
                    if (error.errors[0].title === 'already_exists') {
                        let control = this.roleForm.controls['name'] as FormControl;
                        control.setErrors({'nametaken' : true});
                    } else {
                        this.apiError = error.errors[0].detail;
                    }
                } else {
                    this.apiError = error.error.message;
                }
            }
        );
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/settings/roles/components/role.modal.ts